export default "__VITE_ASSET__CdKi9y8C__"